export const COLORS = {
  WARNING: 'volcano',
  ERROR: 'red',
  SUCCESS: 'green',
};
